exports = module.exports = require("../../../../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".message-body-item__inner p {\n    color: #0F3D57;\n    font-size: 13px;\n}\n\n.contact-message-body-item__customer .message-body-item__inner p {\n    color: #1E293B;\n}\n\n.message-body-item__inner ul > li > a {\n    background: transparent;\n    color: #1785FC;\n    padding: 0px;\n}\n\n.message-body-item__inner ul > li > a:hover {\n    background: transparent !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-scripts/node_modules/css-loader?{"importLoaders":1}!./node_modules/react-scripts/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/MessageRenderer/MarkdownRenderer.css
// module id = ./node_modules/react-scripts/node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/react-scripts/node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/MessageRenderer/MarkdownRenderer.css
// module chunks = 121